var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-img"},[_c('div',{staticClass:"logo-frame"},[(_vm.logo)?_c('div',{staticClass:"company-logo"},[_c('img',{attrs:{"src":_vm.logo}})]):_vm._e(),(_vm.success)?_c('div',{staticClass:"success"},[_c('font-awesome-icon',{attrs:{"icon":"check-circle"}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }